import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=ca56f460&scoped=true"
import script from "./questionList.vue?vue&type=script&lang=js"
export * from "./questionList.vue?vue&type=script&lang=js"
import style0 from "./questionList.vue?vue&type=style&index=0&id=ca56f460&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca56f460",
  null
  
)

export default component.exports